import * as React from 'react';
import LayoutAnonymousCandidate
    from "../../../../../components/layout/layout-anonymous-candidate/layout-anonymous-candidate";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import Seo from "../../../../../components/seo/seo.component";
import CardQuestion from "../../../../../components/card/card-question/card-question.component";

export default function Index() {
    const {t} = useTranslation(['referral_questionnaire_question_1']);
    return (
        <>
            <Seo title={t('_TKEY_SEO_TITLE', { ns: 'referral_questionnaire_question_1' })}/>
            <CardQuestion
                titleHeader={t('_TKEY_REFERRAL_REQUESTION_TITLE', { ns: 'referral_questionnaire_question_1' })}
                numQuestion={t('_TKEY_REFERRAL_REQUESTION_NUMBER', { ns: 'referral_questionnaire_question_1' })}
                question={t('_TKEY_REFERRAL_REQUESTION_1', { ns: 'referral_questionnaire_question_1' })}
                button1Link={'/inscription/formulaire/v4'}
                button1Text={t('_TKEY_REFERRAL_REQUESTION_1_OPTION_1', { ns: 'referral_questionnaire_question_1' })}
                button2Link={'/questionnaire/orientation/question/3'}
                button2Text={t('_TKEY_REFERRAL_REQUESTION_1_OPTION_2', { ns: 'referral_questionnaire_question_1' })}
            />
        </>
    );
}
Index.getLayout = function getLayout(page) {
    return (
        <LayoutAnonymousCandidate>
            {page}
        </LayoutAnonymousCandidate>
    )
}
export async function getStaticProps() {
    return {
        props: {
            ...(await serverSideTranslations(process.env.WEB_SITE_LANGUAGE, ['referral_questionnaire_question_1','common','footer','menu'])),
        },
    };
}